<template>
  <div class="xb-return" id="xbReturn">
    <p class="desc">返修单</p>
    <div class="filter-returnOrder-condition">
      <el-select
        class="returnOrder-classify"
        v-model="returnOrderStatus"
        clearable
        placeholder="选择返修状态"
      >
        <el-option
          v-for="(type, index) in returnOrderStatusList"
          :key="index"
          :label="type.label"
          :value="type.id"
        ></el-option>
      </el-select>
      <el-input
        class="gray"
        v-model="returnOrderSearchKey"
        placeholder="请输入商品名称"
      ></el-input>
      <el-button class="btn-red" @click="filterOrder">筛选</el-button>
    </div>
    <div class="order-list-container">
      <div class="table-img">
        <el-table class="table-container" :data="returnOrderList">
          <el-table-column label="时间" prop="createTime"></el-table-column>
          <el-table-column label="商品名称" prop="goodsName"> </el-table-column>
          <el-table-column label="数量" prop="quantity"></el-table-column>
          <el-table-column label="返修状态" prop="statusName"></el-table-column>
        </el-table>
      </div>
      <div class="pagination-tpl-container">
        <pagination-tpl
          :total="total"
          :currentPage="page"
          @queryChange="onQueryChange"
        ></pagination-tpl>
      </div>
    </div>
  </div>
</template>

<script >
import Dialog from "base/xb-base/Dialog";
import PaginationTpl from "base/PaginationTpl";
import { formatTimeToDate } from "common/js/util.js";
import xbRepair from "models/xb/repair.js";
const xbReturn = new xbRepair();
export default {
  data() {
    return {
      // 初始化当前页面
      currentPage: 1,
      // 返修单筛选--关键字
      returnOrderSearchKey: "",
      // 返修单筛选--订单状态
      returnOrderStatus: "",
      // 返修单类型
      returnOrderStatusList: [
        {
          label: "返修入库",
          id: 1,
        },
        {
          label: "送修出库",
          id: 2,
        },
        {
          label: "完修入库",
          id: 3,
        },
        {
          label: "返修完成",
          id: 4,
        },
      ],
      // 返修单总数
      total: 0,
      page: 1,
      returnOrderList: [],
    };
  },
  methods: {
    // 返修单翻页
    onQueryChange(query) {
      this.page = query.currentPage;
      this._getXBRepairOrderList();
    },
    // 筛选返修单
    filterOrder() {
      this.page = 1;
      this._getXBRepairOrderList();
    },
    _getXBRepairOrderList() {
      let data = {
        currentPage: this.page,
        status: this.returnOrderStatus,
        goodsName: this.returnOrderSearchKey
      }
      xbReturn.getXBRepairList(data).then(res => {
        if (res.success) {
          this.total = res.result.totalNum
          let arr = []
          res.result.items.map(item => {
            let obj = {}
            obj.createTime = formatTimeToDate(item.createTime)
            obj.goodsName = item.goodsName
            obj.quantity = item.quantity
            obj.status = item.status
            this.returnOrderStatusList.map(v => {
              if (v.id == item.status) {
                obj.statusName = v.label
              }
            })
            arr.push(obj)
          })
          console.log(arr);
          this.returnOrderList = arr
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
  },
  created() {
    this._getXBRepairOrderList();
  },
  components: {
    PaginationTpl,
    Dialog,
  },
};
</script>

<style lang="scss" scoped>
.xb-return {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  font-size: 16px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  padding: 0 20px 30px 20px;
  .desc {
    box-sizing: border-box;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(96, 98, 102, 1);
    border-bottom: 1px solid #e4e4e4;
  }
  .filter-returnOrder-condition {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .returnOrder-classify {
      margin-right: 20px;
    }
    .gray {
      width: 220px;
      margin-right: 20px;
    }
    .btn-red {
      height: 32px;
      width: 80px;
      color: #fff;
      border: 0px;
      background: rgba(223, 52, 69, 0.75);
      &:hover {
        background: rgba(223, 52, 69, 1);
      }
    }
  }
  .order-list-container {
    .table-img {
      .has-gutter {
        tr {
          border-radius: 2px 2px 0px 0px;
        }
      }
    }
    .pagination-tpl-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .tip {
      border: 1px solid #e4e4e4;
      height: 80px;
      text-align: center;
      line-height: 80px;
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>

<style lang="scss">
#xbReturn {
  .el-radio-group {
    .el-radio-button {
      border: none;
      box-shadow: none;
      .el-radio-button__inner {
        font-size: 14px;
        border: none;
        padding-left: 0;
        color: #606266;
        background: #fff;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        box-shadow: none;
        color: #df3445;
      }
    }
  }
  .el-select {
    min-width: 134px;
    max-width: 134px;
    margin-right: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      background: rgba(234, 238, 245, 0.2);
      border-radius: 4px;
      border: 1px solid rgba(234, 238, 245, 1);
      padding: 0 20px 0 8px;
      font-size: 14px;
      font-family: "PingFangSC-Regular";
      color: rgba(96, 98, 102, 1);
      letter-spacing: 1px;
      padding-left: 15px;
    }
    .el-input__suffix {
      height: 40px;
      top: -3px;
      right: 0px;
    }
    .is-focus {
      .el-input__inner {
        border: 1px solid rgba(61, 116, 242, 1);
      }
    }
  }
  .el-button:active {
    border: none;
    transform: none;
  }
  .table-img
    .el-table
    .el-table__header-wrapper
    .el-table__header
    tr
    th
    .cell {
    height: 32px;
    background: #f9f9f9;
    font-size: 12px;
    font-weight: 400;
    color: #606266;
    line-height: 28px;
  }
}
</style>